import React, { useEffect, useState, useContext } from "react"
import Header from "../components/Header"
import PreHero from "./PreHero"
import { Link, useLocation } from "react-router-dom"
import Hero from "../components/home/Hero"
import { Context } from "../store/store"
import Footer from "../components/Footer"

const Confirm: React.FC = () => {
	const { globalState, dispatch } = useContext(Context)
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) { }
	}
	const location = useLocation()
	const [winningPrice, setWinningPrice] = useState(0)
	// get userId

	useEffect(() => {
		dispatch({
			type: "RESET",
		}) // strip HTML tags
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
		if (location.state !== null) {
			let preis = location.state.preis
			setWinningPrice(preis)
		}
	}, [])

	return (
		<>
			<div className="light bg-white pb-12">
				<Header />
				<Hero type="winner" />
				<div className="bg-norepeat  relative z-[1200] w-full bg-white bg-cover bg-center bg-repeat-y pt-[0px] lg:pt-[0px]">
					<div className=" mx-auto max-w-[1400px] pt-12 text-center text-white lg:pt-6">
						<h3 className=" h2 mb-12 text-[20px] md:text-[62px] text-blue">Die Daten wurden erfolgreich übermittelt.</h3>
						<p className="mb-12 px-4 font-Alpro  text-[24px] text-blue md:px-0 md:text-[32px]">Du erhältst per E-Mail eine Eingangsbestätigung. Anschließend werden wir die Einhaltung der Teilnahmevoraussetzungen prüfen.
							<br /><br />Viele Grüße<br />
							Dein alpro Team</p>
						<div className="mx-auto mb-1  pb-12  max-w-[80%] md:max-w-full ">
							<Link
								to="/"
								className="mb-6 block w-[100%] bg-blue p-4 font-Alpro text-[24px] font-bold uppercase tracking-wider text-white drop-shadow-md sm:w-[auto] md:text-[32px] trackind-wider rounded-full border-[3px] border-white lg:inline-block lg:py-2 lg:px-6"
							>
								Zurück zur Aktion
							</Link>
						</div>
						<div className="max-w-[90%] mx-auto">
							<p className="mx-auto text-center text-[17px] mb-2 font-[Helvetica] font-[400] leading-[22px] text-blue lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]">Aktionszeitraum vom 05.01.2026 - 08.05.2026.  Kassenbon-Upload möglich bis 08.05.2026.</p>
							<p className="mx-auto text-center text-[17px] mb-2  font-[Helvetica] font-[400] leading-[22px] text-blue lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]">Limitiert auf 50.000
								Erstattungen gesamt</p>
							<p className="mx-auto text-center text-[17px] mb-2 font-[Helvetica] font-[400]  leading-[22px] text-blue lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]">Teilnahme ab 18 Jahren. </p>
							<p className="mx-auto text-center text-[17px] font-[Helvetica] font-[400]  leading-[22px] text-blue lg:max-w-[75%] lg:text-[22px] lg:leading-[37px] mb-6">Der originale Rechnungsbeleg ist aufzubewahren.
								Eine Teilnahme pro Haushalt und IBAN.</p>
							<p className="mx-auto text-center text-[17px] mb-2 font-[Helvetica] font-[400]  leading-[22px] text-blue lg:max-w-[75%] lg:text-[22px] lg:leading-[37px]"> Weitere Informationen in den <a href="/teilnahmebedingungen" target="_blank" className="underline text-orange">Teilnahmebedingungen</a>.</p>
						</div>
					</div>
				</div>
				<div className="">
					<Footer />
				</div>
			</div>
		</>
	)
}
export default Confirm
